import React, { useCallback, useMemo, useState } from 'react';
import { ActionsContext, GridUploadingContext } from './context';
import useChangeModalVisible from '../../../../../../../../hooks/useChangeModalVisible';
import AddAccountModal from '../../../../../../components/ui/modals/AddAccountModal/AddAccountModal';
import AddTenantModal from '../../../../../../components/ui/modals/AddTenantModal/AddTenantModal';
import { ChessModalWrapper } from '../../../../../../components/ui/modals/ChessModalWrapper/ChessModalWrapper';
import useCurrentAddress from '../../../../../../hooks/useCurrentAddress';
import useFlatsGridState from '../../../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../../../hooks/useHousingStockState';

export const ModalsProvider = ({ children }) => {
  const [flatData, setFlatData] = useState(null);

  const address = useCurrentAddress();

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const {
    visible: addAccountModalVisible,
    showModal: showAddAccountModal,
    hideModal: hideAddAccountModal,
  } = useChangeModalVisible();

  const {
    visible: addTenantModalVisible,
    showModal: showAddTenantModal,
    hideModal: hideAddTenantModal,
  } = useChangeModalVisible();

  const {
    visible: flatsGridModalVisible,
    showModal: showFlatsGridModal,
    hideModal: hideFlatsGridModal,
  } = useChangeModalVisible();

  const {
    visible: isFlatsGridUploading,
    showModal: showFlatsGridUploading,
    hideModal: hideFlatsGridUploading,
  } = useChangeModalVisible();

  const openAddAccountOrTenantModal = useCallback(
    (key, flatData) => {
      setFlatData(flatData);

      if (key === 'account') {
        showAddAccountModal();
      }

      if (key === 'tenant') {
        showAddTenantModal();
      }
    },
    [showAddAccountModal, showAddTenantModal]
  );

  const handleModalsCancel = () => {
    setFlatData(null);
    hideAddAccountModal();
    hideAddTenantModal();
  };

  const actions = useMemo(
    () => ({
      showFlatsGridModal,
      hideFlatsGridModal,
      showFlatsGridUploading,
      hideFlatsGridUploading,
      openAddAccountOrTenantModal,
    }),
    [
      showFlatsGridModal,
      hideFlatsGridModal,
      showFlatsGridUploading,
      hideFlatsGridUploading,
      openAddAccountOrTenantModal,
    ]
  );

  return (
    <GridUploadingContext.Provider value={isFlatsGridUploading}>
      <ActionsContext.Provider value={actions}>
        {children}
        <AddAccountModal
          visible={addAccountModalVisible}
          onCancel={handleModalsCancel}
          address={address}
          addressId={flatData?.addressId}
          queryKeys={[flatsGridQueryKey, housingStockQueryKey]}
        />
        <AddTenantModal
          visible={addTenantModalVisible}
          onCancel={handleModalsCancel}
          address={address}
          addressId={flatData?.addressId}
          queryKeys={[flatsGridQueryKey, housingStockQueryKey]}
        />
        <ChessModalWrapper
          visible={flatsGridModalVisible}
          onCancel={hideFlatsGridModal}
          address={address}
        />
      </ActionsContext.Provider>
    </GridUploadingContext.Provider>
  );
};
